import { DOCTOR_LISTING, UPDATE_DOCTOR_LISTING_INDEX_CHARACTERS, RESET_DOCTOR_LISTING_INDEX_CHARACTERS } from "../actions/type";
const INITIAL_STATE = {
  doctorList: [],
  location: [],
  hospitals: [],
  languagesSet: [],
  indexCharacters: [],
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case DOCTOR_LISTING:

      let newStet = payload.doctors?.doctorDetails
      let oldState = state.doctorList?.doctorDetails

      // if (oldState && (!payload.speciality||payload.speciality=="ALL" )) {

      //   payload.doctors.doctorDetails=[...oldState,...newStet]

      // }

      // Merge indexCharacters - keep unique values only
      const newIndexCharacters = payload.indexCharacters || [];
      const existingIndexCharacters = state.indexCharacters || [];
      const mergedIndexCharacters = [...new Set([...existingIndexCharacters, ...newIndexCharacters])];

      console.log("🔄 DOCTOR_LISTING - Merging indexCharacters:", {
        existing: existingIndexCharacters,
        new: newIndexCharacters,
        merged: mergedIndexCharacters
      });

      return {
        ...state,
        doctorList: payload.doctors,
        location: payload.location,
        hospitals: payload.hospitals,
        languagesSet: payload.languagesSet,
        indexCharacters: mergedIndexCharacters,
      };

    case UPDATE_DOCTOR_LISTING_INDEX_CHARACTERS:
      // Only update indexCharacters, keep everything else the same
      const updatedIndexCharacters = payload.indexCharacters || [];
      const currentIndexCharacters = state.indexCharacters || [];
      const accumulatedIndexCharacters = [...new Set([...currentIndexCharacters, ...updatedIndexCharacters])];

      console.log("✅ UPDATE_INDEX_CHARACTERS - Accumulating:", {
        current: currentIndexCharacters,
        new: updatedIndexCharacters,
        accumulated: accumulatedIndexCharacters
      });

      return {
        ...state,
        indexCharacters: accumulatedIndexCharacters,
      };

    case RESET_DOCTOR_LISTING_INDEX_CHARACTERS:
      console.log("🔄 RESET_INDEX_CHARACTERS - Resetting to []");
      return {
        ...state,
        indexCharacters: [],
      };

    default:
      return state;
  }
};
